import React from 'react';

import { money, percent } from './formatting';

import WarningIcon from 'Assets/icons/exclamation-triangle.svg';

/** Budget value, allocated and unallocated with their share, and the lines needing attention. */
export default function AllocationStrip({ total }) {
    const share = (value) => (total.budget > 0 ? percent((value / total.budget) * 100) : '');

    return (
        <div className="tw-flex tw-flex-wrap tw-gap-x-5 tw-gap-y-1 tw-px-5 tw-pt-3 tw-text-xs tw-text-charcoal-50">
            <span>
                {$t('Budget value')} <b className="tw-font-semibold tw-text-charcoal">{money(total.budget)}</b>
            </span>
            <span>
                {$t('Allocated')} <b className="tw-font-semibold tw-text-charcoal">{money(total.allocated)}</b>{' '}
                {share(total.allocated) && `(${share(total.allocated)})`}
            </span>
            <span className={total.unallocated > 0.5 ? 'tw-font-medium tw-text-amber-700' : ''}>
                {$t('Unallocated')} <b className="tw-font-semibold">{money(total.unallocated)}</b> {share(total.unallocated) && `(${share(total.unallocated)})`}
            </span>
            {total.overCount > 0 && (
                <span className="tw-inline-flex tw-items-center tw-gap-x-1 tw-font-medium tw-text-red">
                    <WarningIcon className="tw-h-3 tw-w-3" aria-hidden="true" />
                    {total.overCount === 1 ? $t('1 line over 100%') : $t('{{count}} lines over 100%', { count: total.overCount })}
                </span>
            )}
            {total.unallocatedCount > 0 && (
                <span>
                    {total.unallocatedCount === 1
                        ? $t('1 line with no allocation')
                        : $t('{{count}} lines with no allocation', { count: total.unallocatedCount })}
                </span>
            )}
        </div>
    );
}
